import React from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { getNotLinkedDirs, getNotLinkedEmails, getNotLinkedItemsDictionaries } from './actions';
import AppLayout from '../../layouts/AppLayout';
import GlobalStyled from './components/Global.styled';
import moment from 'moment';
import NotLinkedItemsView from './components/NotLinkedItemsView';
import PageComponent from '../../components/PageComponent';
import { prepareFile } from '../StorageManager/actions';
import NotLinkedItemsFilters from './components/Filters';
import { getSmartDateRange } from '../../holidayUtils';

class NotLinkedItems extends PageComponent {
  constructor(props) {
    super(props);
    // Initialize state from URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const dateFromParam = queryParams.get('dateFrom');
    const dateToParam = queryParams.get('dateTo');

    // Use smart date range logic if no URL parameters provided
    const smartRange = getSmartDateRange();

    this.state = {
      dateFrom: dateFromParam ? moment(dateFromParam) : smartRange.dateFrom,
      dateTo: dateToParam ? moment(dateToParam) : smartRange.dateTo,
    };
  }

  componentDidMount() {
    // Log smart date range calculation
    const today = moment();
    const dayOfWeek = today.format('dddd');
    const previousWorkingDay = this.state.dateFrom.format('dddd, YYYY-MM-DD');
    console.log(`Today is ${dayOfWeek}. Previous working day was: ${previousWorkingDay}`);
    console.log(`Smart date range: ${this.state.dateFrom.format('YYYY-MM-DD')} to ${this.state.dateTo.format('YYYY-MM-DD')}`);

    const daysCovered = this.state.dateTo.diff(this.state.dateFrom, 'days') + 1;
    console.log(`Date range covers ${daysCovered} day(s) (from last working day until today)`);

    // Load dictionaries for filters
    this.props.dispatch(getNotLinkedItemsDictionaries({
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    }));
    
    // Dispatch action on component mount
    // Pass current dateFrom and dateTo from state if needed, or fetch all initially
    this.props.dispatch(getNotLinkedDirs({
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    }));
    this.props.dispatch(getNotLinkedEmails({
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    }));
  }

  handleApplyFilters = (filters) => {
    const { dateFrom, dateTo, clientServiceUser, seriesNameOrCode, clientName, woLinked } = filters;
    const preparedDateFrom = moment(dateFrom);
    const preparedDateTo = moment(dateTo);
    this.setState({ 
      dateFrom: preparedDateFrom,
      dateTo: preparedDateTo,
      clientServiceUser,
      seriesNameOrCode,
      clientName,
      woLinked
    });
    this.props.dispatch(getNotLinkedDirs({
      dateFrom: preparedDateFrom,
      dateTo: preparedDateTo,
      clientServiceUser,
      seriesNameOrCode,
      clientName,
      woLinked
    }));
    this.props.dispatch(getNotLinkedEmails({
      dateFrom: preparedDateFrom,
      dateTo: preparedDateTo,
      clientServiceUser,
      seriesNameOrCode,
      clientName,
      woLinked
    }));
    this.props.dispatch(getNotLinkedItemsDictionaries({
      dateFrom: preparedDateFrom,
      dateTo: preparedDateTo
    }));
  };

  handleLoadMoreEmails = () => {
    const { nextMessageId } = this.props;
    if (nextMessageId) {
      this.props.dispatch(getNotLinkedEmails({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo,
        nextMessageId: nextMessageId,
        clientServiceUser: this.state.clientServiceUser,
        seriesNameOrCode: this.state.seriesNameOrCode,
        clientName: this.state.clientName,
        woLinked: this.state.woLinked
      }));
    }
  };

  handleLoadMoreDirs = () => {
    const { nextFilename } = this.props;
    if (nextFilename) {
      this.props.dispatch(getNotLinkedDirs({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo,
        nextFilename: nextFilename,
        clientServiceUser: this.state.clientServiceUser,
        seriesNameOrCode: this.state.seriesNameOrCode,
        clientName: this.state.clientName,
        woLinked: this.state.woLinked
      }));
    }
  };

  render() {
    const { notLinkedDirs, notLinkedEmails, nextMessageId, nextFilename, loaders, csUserList, clientList } = this.props;

    const notLnkedDirsPrepared = notLinkedDirs.map(dir => prepareFile(dir, this.props.fsRoots));

    const filters = (
      <NotLinkedItemsFilters
        applyFilters={this.handleApplyFilters}
        dateFrom={this.state.dateFrom.toDate()}
        dateTo={this.state.dateTo.toDate()}
        csUserList={csUserList}
        clientList={clientList}
      />
    );

    return (
      <AppLayout
        title="Orphaned Items"
        className="not-linked-items-page"
        //filters={filters}
      >
        <div className="not-linked-items-page-content">
        { filters }
        <NotLinkedItemsView
          notLinkedDirs={notLnkedDirsPrepared}
          notLinkedEmails={notLinkedEmails}
          nextFilename={nextFilename}
          nextMessageId={nextMessageId}
          loaders={loaders}
          onLoadMoreDirs={this.handleLoadMoreDirs}
          onLoadMoreEmails={this.handleLoadMoreEmails}
        />
        </div>
        <GlobalStyled />
      </AppLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const {notLinkedItems, user, storageManager} = state;
  return {
    user,
    notLinkedDirs: notLinkedItems.notLinkedDirs,
    notLinkedEmails: notLinkedItems.notLinkedEmails,
    nextFilename: notLinkedItems.nextFilename,
    nextMessageId: notLinkedItems.nextMessageId,
    csUserList: notLinkedItems.csUserList,
    clientList: notLinkedItems.clientList,
    loaders: notLinkedItems.loaders,
    fsRoots: storageManager.fsRoots,
  };
};

export default connect(mapStateToProps)(withRouter(NotLinkedItems));
